import { render, staticRenderFns } from "./Booking_detail.vue?vue&type=template&id=d5ed6d90"
import script from "./Booking_detail.vue?vue&type=script&lang=js"
export * from "./Booking_detail.vue?vue&type=script&lang=js"
import style0 from "./Booking_detail.vue?vue&type=style&index=0&id=d5ed6d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports